import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue"
import KeywordField from "@/components/fields/KeywordField.vue"

type Tag = {
  tags: string[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ManageTags',
  props: {
    tags: null
  },
  setup(__props: any) {



const form = ref<Tag>({
  tags: [],
})

const showTagsModal = ref(false)

return { __sfc: true,form, showTagsModal, KeywordField }
}

})